"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _OutlinedInput = _interopRequireDefault(require("@mui/material/OutlinedInput"));
var _styles = require("@mui/styles");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["classes", "borderStyle"],
  _excluded2 = ["notchedOutline", "root", "borderStyle"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var styles = function styles(theme) {
  return {
    borderStyle: {
      borderStyle: function borderStyle(_ref) {
        var _borderStyle = _ref.borderStyle;
        return _borderStyle;
      }
    },
    // darkRoot: {
    //   color: theme.palette.common.white,
    //   "&:hover $darkNotchedOutline": {
    //     borderColor: theme.palette.common.white,
    //   },
    //   "&$focused $darkNotchedOutline": {
    //     borderColor: theme.palette.common.white,
    //   },
    //   "&$disabled $darkNotchedOutline": {
    //     borderColor: theme.palette.action.disabled,
    //   },
    // },
    // darkNotchedOutline: {
    //   borderColor: "rgba(255, 255, 255, 0.23)",
    // },
    focused: {},
    disabled: {},
    inputAdornedEnd: {
      paddingRight: '56px !important'
    },
    root: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var classesProp = _ref2.classes,
    borderStyle = _ref2.borderStyle,
    props = _objectWithoutProperties(_ref2, _excluded);
  var notchedOutline = classesProp.notchedOutline,
    root = classesProp.root,
    borderStyleClassName = classesProp.borderStyle,
    classes = _objectWithoutProperties(classesProp, _excluded2);
  var notchedOutlineClassNameArray = [notchedOutline];
  var rootClassNameArray = [root];

  // if (dark) {
  //   notchedOutlineClassNameArray.push(darkNotchedOutline);
  //   rootClassNameArray.push(darkRoot);
  // }

  if (borderStyle) {
    notchedOutlineClassNameArray.push(borderStyleClassName);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutlinedInput["default"], _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    classes: _objectSpread({
      root: rootClassNameArray.filter(function (c) {
        return c;
      }).join(" "),
      notchedOutline: notchedOutlineClassNameArray.filter(function (c) {
        return c;
      }).join(" ")
    }, classes)
  }));
});
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: "GgOutlinedInput"
})(OutlinedInput);